import React from 'react'
import { ImageManager } from 'Core/imageManager'
import { Wrapper } from 'SRC/ui/FormElements'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { setNewBanner } from '../../../../../actions'
import { getUserInfo, getNewBanner } from '../../../../../selectors'
import { imagesCDN } from 'Core/constants'
import { Preloader } from 'SRC/ui/Preloader'

export class Image extends React.Component {
  constructor (props) {
    super(props)

    this.imageManager = new ImageManager()
    this.maxWidth = 315
    this.maxHeight = 195
    this.state = {isLoading: true}
    this.isComponentMounted = true
  }

  async componentDidMount () {
    if (this.props.existingBanner) {
      const arStrings = this.props.existingBanner.split('/')
      const name = arStrings[arStrings.length - 1]
      this.imageManager.loadImageFromUrl(`${imagesCDN}${this.props.existingBanner}`).then(image => {
        if (this.isComponentMounted) {
          this.props.setNewBanner({file: image.file, name, isOriginal: true})
          this.setState({...this.state, isLoading: false})
        }
      }).catch(() => {
        if (this.isComponentMounted) {
          this.props.setNewBanner({file: '', name})
          this.setState({...this.state, isLoading: false})
        }
      })
    } else {
      this.setState({...this.state, isLoading: false})
    }
  }

  componentWillUnmount () {
    this.isComponentMounted = false
  }

  onChange = e => {
    if (!this.props.isFormBlocked) {
      const image = e.target.files[0]
      this.imageManager.loadImage(image).then(
        file => this.imageManager.resizeImage(file, {width: this.maxWidth, height: this.maxHeight})
      ).then(
        file => this.props.setNewBanner({file, name: image.name})
      )
    }
  }

  removeImage = () => {
    if (!this.props.isFormBlocked) {
      this.props.setNewBanner(null)
    }
  }

  render () {
    return [
      <input
        id='banner'
        name='banner'
        type='file'
        accept={this.imageManager.allowedTypes.join(',')}
        style={{display: 'none'}}
        onChange={this.onChange}
        key='input'
        disabled={this.props.isFormBlocked}
      />,
      !this.props.newBanner && !this.props.existingBanner
        ? <Wrapper isFullWidth key='addLogoBtn'>
          <label className='dodaj-logo' htmlFor='banner' key='label' style={{textAlign: 'center'}}>
            <i className='ico-tab-fotografije ico' />
            Dodaj baner
          </label>
        </Wrapper>
        : <div className='dodaj-banner-group' style={{marginBottom: '15px'}} key='editBanner'>
          {this.state.isLoading
            ? <Preloader />
            : <div className='banner-img' key='banner'>
              {this.props.newBanner && this.props.newBanner.file ? <img src={this.props.newBanner.file} /> : null}
            </div>
          }
          <div className='banner-btns' key='buttons'>
            <label htmlFor='banner'><i className='ico ico-poslate-poruke' />Dodaj</label>
            <a
              onClick={this.removeImage}
              style={this.props.newBanner && this.props.newBanner.file ? null : {display: 'none'}}
            >
              <i className='ico ico-obrisati' />Obriši
            </a>
          </div>
        </div>
    ]
  }
}

Image.propTypes = {
  newBanner: PropTypes.shape({
    file: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isOriginal: PropTypes.bool
  }),
  setNewBanner: PropTypes.func.isRequired,
  isFormBlocked: PropTypes.bool.isRequired,
  existingBanner: PropTypes.string
}

Image.defaultProps = {
  isFormBlocked: false
}

const mapStateToProps = state => {
  const props = {newBanner: getNewBanner(state)}
  const userInfo = getUserInfo(state)
  if (userInfo.media && Array.isArray(userInfo.media)) {
    const banner = userInfo.media.filter(item => item.title === 'banner-image')
    if (banner.length) {
      props.existingBanner = banner[0].fd
    }
  }
  return props
}

export default connect(mapStateToProps, {setNewBanner})(Image)
